export type ConversionType =
  | "inches-mm"
  | "mm-inches"
  | "radius-diameter"
  | "diameter-radius"
  | "lh-ls"
  | "ls-lh"
  | "m3h-ls"
  | "ls-m3h"
  | "etrs89-wgs84"
  | "wgs84-etrs89"
  | "cv-kw"
  | "kw-cv"
  | "m3d-ls"
  | "ls-m3d";

export const conversions = [
  {
    label: "converter.conversions.etrs89-wgs84",
    value: "etrs89-wgs84",
    inputUnit: "converter.units.m",
    outputUnit: "converter.units.degrees",
  },
  {
    label: "converter.conversions.wgs84-etrs89",
    value: "wgs84-etrs89",
    inputUnit: "converter.units.degrees",
    outputUnit: "converter.units.m",
  },
  {
    label: "converter.conversions.inches-mm",
    value: "inches-mm",
    inputUnit: "converter.units.in",
    outputUnit: "converter.units.mm",
  },
  {
    label: "converter.conversions.mm-inches",
    value: "mm-inches",
    inputUnit: "converter.units.mm",
    outputUnit: "converter.units.in",
  },
  {
    label: "converter.conversions.radius-diameter",
    value: "radius-diameter",
    inputUnit: "converter.units.m",
    outputUnit: "converter.units.m",
  },
  {
    label: "converter.conversions.diameter-radius",
    value: "diameter-radius",
    inputUnit: "converter.units.m",
    outputUnit: "converter.units.m",
  },
  {
    label: "converter.conversions.ls-lh",
    value: "ls-lh",
    inputUnit: "converter.units.ls",
    outputUnit: "converter.units.lh",
  },
  {
    label: "converter.conversions.lh-ls",
    value: "lh-ls",
    inputUnit: "converter.units.lh",
    outputUnit: "converter.units.ls",
  },
  {
    label: "converter.conversions.ls-m3h",
    value: "ls-m3h",
    inputUnit: "converter.units.ls",
    outputUnit: "converter.units.m3h",
  },
  {
    label: "converter.conversions.m3h-ls",
    value: "m3h-ls",
    inputUnit: "converter.units.m3h",
    outputUnit: "converter.units.ls",
  },
  {
    label: "converter.conversions.cv-kw",
    value: "cv-kw",
    inputUnit: "converter.units.cv",
    outputUnit: "converter.units.kw",
  },
  {
    label: "converter.conversions.kw-cv",
    value: "kw-cv",
    inputUnit: "converter.units.kw",
    outputUnit: "converter.units.cv",
  },
  {
    label: "converter.conversions.ls-m3d",
    value: "ls-m3d",
    inputUnit: "converter.units.ls",
    outputUnit: "converter.units.m3d",
  },
  {
    label: "converter.conversions.m3d-ls",
    value: "m3d-ls",
    inputUnit: "converter.units.m3d",
    outputUnit: "converter.units.ls",
  },
];
